import forOwn from 'mout/object/forOwn'
import contains from 'mout/array/contains'

export default function getStudentsByClass(students, record, notInClass) {
  let studentsInClass = [], output = []
  forOwn(record.students, function pushTrueStudents(bool, studentId) {
    if (bool) studentsInClass.push(studentId)
  })
  if (notInClass) {
    forOwn(students, function pushStudentsNotIn(student, id) {
      if (!contains(studentsInClass, student.id)) output.push(student)
    })
  } else {
    forOwn(students, function pushStudentsIn(student, id) {
      if (contains(studentsInClass, student.id)) output.push(student)
    })
  }
  return output
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/getStudentsByClass.js